import { render } from "./TrainingAttendingView.vue?vue&type=template&id=c1b9f4cc&scoped=true"
import script from "./TrainingAttendingView.vue?vue&type=script&lang=js"
export * from "./TrainingAttendingView.vue?vue&type=script&lang=js"

import "./TrainingAttendingView.vue?vue&type=style&index=0&id=c1b9f4cc&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1b9f4cc"]])

export default __exports__